import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import global_ from './Global'
Vue.prototype.GLOBAL = global_

new Vue({
  render: h => h(App),
}).$mount('#app')
